import { axiosInstance } from './httpClient';
import { API } from './env';

const getAuthConfig = () => {
  const userInfo = JSON.parse(localStorage.getItem('user'));
  const accessToken = userInfo.token;
  return {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  };
};

export default class JobReferralsApi {
  // ─── Jobs ───────────────────────────────────────────────────────────────

  static getJobs = (companyId) => {
    const params = companyId ? `?companyId=${companyId}` : '';
    return axiosInstance.get(`${API}/admin/job-referrals/jobs${params}`, getAuthConfig());
  };

  static createJob = (body) => {
    return axiosInstance.post(
      `${API}/admin/job-referrals/jobs`,
      JSON.stringify(body),
      getAuthConfig()
    );
  };

  static updateJob = (id, body) => {
    return axiosInstance.patch(
      `${API}/admin/job-referrals/jobs/${id}`,
      JSON.stringify(body),
      getAuthConfig()
    );
  };

  // ─── Referrals ──────────────────────────────────────────────────────────

  static getReferrals = ({ companyId, status, dateFrom, dateTo, page, limit } = {}) => {
    const params = new URLSearchParams();
    if (companyId) params.set('companyId', companyId);
    if (status) params.set('status', status);
    if (dateFrom) params.set('dateFrom', dateFrom);
    if (dateTo) params.set('dateTo', dateTo);
    if (page) params.set('page', page);
    if (limit) params.set('limit', limit);
    const qs = params.toString() ? `?${params.toString()}` : '';
    return axiosInstance.get(`${API}/admin/job-referrals/referrals${qs}`, getAuthConfig());
  };

  static updateReferralStatus = (id, status, hireDate, bonusAmount, candidateGovId) => {
    const body = { status };
    if (hireDate) body.hireDate = hireDate;
    if (bonusAmount !== undefined) body.bonusAmount = bonusAmount;
    if (candidateGovId) body.candidateGovId = candidateGovId;
    return axiosInstance.patch(
      `${API}/admin/job-referrals/referrals/${id}/status`,
      JSON.stringify(body),
      getAuthConfig()
    );
  };

  // ─── Rewards ────────────────────────────────────────────────────────────

  static getRewards = (status, companyId, page, limit) => {
    const params = new URLSearchParams();
    if (status) params.set('status', status);
    if (companyId) params.set('companyId', companyId);
    if (page) params.set('page', page);
    if (limit) params.set('limit', limit);
    const qs = params.toString() ? `?${params.toString()}` : '';
    return axiosInstance.get(`${API}/admin/job-referrals/rewards${qs}`, getAuthConfig());
  };

  static updateReward = (id, action) => {
    return axiosInstance.patch(
      `${API}/admin/job-referrals/rewards/${id}`,
      JSON.stringify({ action }),
      getAuthConfig()
    );
  };

  static reverifyReward = (id, candidateGovId) => {
    const body = {};
    if (candidateGovId) body.candidateGovId = candidateGovId;
    return axiosInstance.post(
      `${API}/admin/job-referrals/rewards/${id}/reverify`,
      JSON.stringify(body),
      getAuthConfig()
    );
  };

  // ─── CV ─────────────────────────────────────────────────────────────────

  static getCvSignedUrl = (referralId) => {
    return axiosInstance.get(
      `${API}/admin/job-referrals/referrals/${referralId}/cv`,
      getAuthConfig()
    );
  };
}
